export default "__VITE_ASSET__CGQy_2Ft__"